<div *ngIf="filtersForm" [formGroup]="filtersForm">
  <mat-card-title class="filters-header tw-flex tw-flex-col">
    <ng-container
      *ngTemplateOutlet="
        titleTemplate;
        context: {
          filtersForm: filtersForm,
          profileForm: selectedProfileForm
        }
      "
    ></ng-container>
  </mat-card-title>

  <div class="filters-list_sticky scroll-decor">
    <div
      cdkDropList
      #enabledList="cdkDropList"
      [cdkDropListDisabled]="!isCustomizedMode"
      [cdkDropListData]="enabledFilters"
      [cdkDropListConnectedTo]="[disabledList]"
      class="drop-list drop-list_enabled"
      (cdkDropListDropped)="drop($event)"
    >
      <div *ngIf="isCustomizedMode" class="active-filters-title">
        {{ 'common.uiKit.monitoring.label.enabled' | translate }}
      </div>
      <ui-monitoring-filters-field
        *ngFor="let filterName of enabledFilters"
        [filterTypeByName]="filterTypeByName"
        [filterSelectOptionsByName]="filterSelectOptionsByName"
        [label]="'monitoring.filters.' + filterName | translate"
        [name]="filterName"
        [isFieldEnabled]="true"
        [isDraggedMode]="isCustomizedMode"
        [filtersFormControlOrGroup]="filtersForm.get(filterName)"
        [optionValueKeyForChipsInputSearchGeneric]="chipsInputOptionValueMap.get(filterName)"
        [optionNameKeyForChipsInputSearchGeneric]="recordTypeFilterMap.get(filterName)"
        [searchCheckboxAutocompleteWidth]="searchCheckboxAutocompleteWidth.get(filterName)"
        [splitPattern]="chipsInputSplitPatternMap.get(filterName)"
        cdkDrag
        (changeFieldState)="changeFieldState($event, transportFiltersState.Disabled)"
      ></ui-monitoring-filters-field>
    </div>

    <div
      cdkDropList
      #disabledList="cdkDropList"
      [hidden]="!isCustomizedMode"
      [cdkDropListDisabled]="!isCustomizedMode"
      [cdkDropListData]="disabledFilters"
      [cdkDropListConnectedTo]="[enabledList]"
      class="drop-list drop-list_disabled"
      (cdkDropListDropped)="drop($event)"
    >
      <div *ngIf="isCustomizedMode" class="active-filters-title">
        {{ 'common.uiKit.monitoring.label.disabled' | translate }}
      </div>
      <ui-monitoring-filters-field
        *ngFor="let filterName of disabledFilters"
        [filterTypeByName]="filterTypeByName"
        [filterSelectOptionsByName]="filterSelectOptionsByName"
        [label]="'monitoring.filters.' + filterName | translate"
        [name]="filterName"
        [isFieldEnabled]="false"
        [isDraggedMode]="isCustomizedMode"
        [filtersFormControlOrGroup]="filtersForm.get(filterName)"
        cdkDrag
        (changeFieldState)="changeFieldState($event, transportFiltersState.Enabled)"
      ></ui-monitoring-filters-field>
    </div>
  </div>
</div>

<ng-template #titleTemplate let-profileForm="profileForm" let-filtersForm="filtersForm">
  <ng-container *ngIf="!isCustomizedMode; else filterSettingsTitleTemplate">
    <div class="tw-flex tw-h-8">
      <div class="filters-header__icon">
        <ui-svg-icon [name]="iconNameList.Filter" [width]="32" class="tw-ml-0"></ui-svg-icon>
        <ui-svg-icon
          *ngIf="!isCustomizedMode && isFiltersCustomizable"
          [name]="iconNameList.Edit"
          [width]="20"
          class="edit-filters"
          (click)="enableCustomizeMode.emit()"
        ></ui-svg-icon>
      </div>

      <ui-action-button
        class="apply-filters-button"
        [action]="buttonAction.Apply"
        [size]="buttonSize.XS"
        [disabled]="filtersForm.invalid || filtersForm.pristine"
        (buttonClick)="apply()"
      ></ui-action-button>
      <ng-container *ngIf="canCreateOrUpdateProfile && isProfileVisible">
        <ui-action-button
          *ngIf="filtersForm.valid && filtersForm.pristine && !profileForm.value?.id"
          class="apply-filters-button"
          [action]="buttonAction.Apply"
          [text]="'monitoring.materialPlannerProfile.button.createProfile' | translate"
          [size]="buttonSize.XS"
          (buttonClick)="openCreateProfileDialog.emit()"
        ></ui-action-button>
      </ng-container>
    </div>

    <ui-select-profile
      *ngIf="isProfileVisible"
      [name]="profileForm.get('name').value"
      [id]="profileForm.get('id').value"
      [isUpdateProfileAvailable]="isUpdateProfileAvailable"
      [defaultProfileControl]="defaultProfileControl"
      (removeProfile)="removeProfile.emit()"
      (selectProfile)="selectProfile.emit()"
      (updateProfile)="updateProfile.emit()"
    ></ui-select-profile>
  </ng-container>
</ng-template>

<ng-template #filterSettingsTitleTemplate>
  <div class="filters-config tw-flex">
    <button class="filters-config__back-btn size-md" mat-icon-button (click)="cancelUpdatingFilterSettings.emit()">
      <ui-svg-icon [name]="iconNameList.BackLeft" class="tw-mr-0"></ui-svg-icon>
    </button>

    <div class="filters-config__title">
      {{ 'common.uiKit.monitoring.label.filtersConfig' | translate }}
    </div>
    <ui-action-button
      class="apply-filters-button"
      [action]="buttonAction.Apply"
      [size]="buttonSize.XS"
      [text]="'common.button.save' | translate"
      (buttonClick)="updateFilterSettings.emit()"
    ></ui-action-button>
  </div>
</ng-template>
